import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Popup from './components/Popup/Popup';
import { BrowserRouter } from 'react-router-dom';





const root = ReactDOM.createRoot(document.getElementById('root'));




root.render(

  <React.StrictMode>
    <BrowserRouter>

    <App />

    <Popup/>
    </BrowserRouter>


    

  </React.StrictMode>
);

reportWebVitals();
